import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStudent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.4451 17.8377L12.8171 22.0776L5.18901 17.8377V10.9163L0.976624 8.57803L12.8171 2L24.9755 8.75466V17.5066H23.3103V9.32586L20.4451 10.9163V17.8377ZM21.159 8.57814L12.8171 3.94373L4.47514 8.57814L12.8171 13.2125L21.159 8.57814ZM18.78 16.8298V11.8402L12.8171 15.1562L6.85417 11.8402V16.8298L12.8171 20.1337L18.78 16.8298Z",
		fill: "current"
	})
});
export default SvgStudent;
